module.exports = "<div ng-repeat=\"(key, values) in activeFilters\"> <span class=bug ng-repeat=\"value in values track by $index\"> <svg class=iconic ng-click=\"removeFilter(key, value)\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg") + "#circle-x></use> </svg> <span><em><translate translate=global_filter.filter_tabs.{{key}}></translate>:</em> {{ transformFilterValue(value, key) }}</span> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/filters/active-filters.html
// module id = 769
// module chunks = 0